export default function Results() {
  const results = [
    {
      icon: 'ri-eye-line',
      title: 'Full Control and Transparency of Expenses',
      description: 'You see every ruble and understand where it goes and what result it brings'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Systematic Income Growth Every Month',
      description: 'Predictable profit increase thanks to well-established processes'
    },
    {
      icon: 'ri-team-line',
      title: 'Autonomous Marketing Department',
      description: 'The system works without your constant participation, freeing up time for business'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Dominance on Ozon and in Search Engines',
      description: 'Your products and services in top positions, ahead of competitors'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Flow of Loyal Customers',
      description: 'Not just buyers, but brand advocates who come back again'
    },
    {
      icon: 'ri-funds-line',
      title: 'Budget Optimization up to 40%',
      description: 'AI algorithms find the most effective channels and cut off non-working ones'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            What Will You Get After System Implementation?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Concrete results that will change your business
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {results.map((result, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-slate-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className={`${result.icon} text-2xl text-green-600`}></i>
                </div>
                <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-lg"></i>
                </div>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                {result.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {result.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-3xl p-12 text-center shadow-2xl">
          <div className="max-w-3xl mx-auto">
            <i className="ri-rocket-2-line text-6xl text-white mb-6"></i>
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Ready for Transformation?
            </h3>
            <p className="text-xl text-white/90 mb-8">
              You will see the first results within 30 days after launching the system
            </p>
            <button 
              onClick={() => {
                const element = document.getElementById('lead-form');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-10 py-5 bg-white hover:bg-gray-100 text-cyan-600 text-lg font-semibold rounded-xl transition-all duration-300 shadow-xl whitespace-nowrap cursor-pointer"
            >
              Start Right Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
